/**
 * THE ONE-TIME RESET TO THE PLATFORM'S LOOK, the pure half (Hamzah, 2026-11-03). Kept apart from `theme.ts`,
 * whose stores write to <html> the moment they are imported, so it can be tested without a document;
 * `theme.ts` runs it at load and re-exports it. See the note there for why and when.
 */
export const LOOK_RESET_KEY = 'lumen_look_reset';
export const LOOK_RESET_MARK = '2026-11-03-thunder-glass';
const LOOK_RESET_KEYS = ['lumen_look', 'lumen_look_paint', 'lumen_surface', 'lumen_theme', 'lumen_mode_before_v2', 'lumen.layout.v1'] as const;

/** Put this browser back on the platform's look, once. `preview` (the Settings preview's embed) never resets. */
export function resetLookOnce(storage: Pick<Storage, 'getItem' | 'setItem' | 'removeItem'> | null, preview = false): boolean {
  if (storage === null || preview) return false;
  try {
    if (storage.getItem(LOOK_RESET_KEY) === LOOK_RESET_MARK) return false;
    for (const k of LOOK_RESET_KEYS) storage.removeItem(k);
    storage.setItem(LOOK_RESET_KEY, LOOK_RESET_MARK);
    return true;
  } catch {
    return false;
  }
}
